import { Injectable } from '@angular/core';

export type EventHandler = (body) => any;
export enum ModalType {
  INFO = "info",
  SUCESS = "success",
  WARNING = "warning"
}
@Injectable()
export class ModalService {
  private c = new Map<string, EventHandler[]>();

  constructor() { }

  onShow(modalType : ModalType,...handlers: EventHandler[]) {
    this.subscribe("show-"+modalType, ...handlers);
  }

  onHide(modalType : ModalType, ...handlers: EventHandler[]) {
    this.subscribe('hide-'+modalType, ...handlers);
  }

  offShow(modalType : ModalType, handler?: EventHandler): boolean {
    return this.unsubscribe("show-"+modalType, handler);
  }

  offHide(modalType : ModalType, handler?: EventHandler): boolean {
    return this.unsubscribe('hide-'+modalType, handler);
  }

  show(modalType : ModalType, body: any): EventHandler[] | null {
    return this.publish("show-"+modalType, body)
  }

  hide(modalType : ModalType): EventHandler[] | null {
    return this.publish('hide-'+modalType, {})
  }

  private subscribe(channel: string, ...handlers: EventHandler[]): void {
    let topics = this.c.get(channel);
    if (!topics) {
      this.c.set(channel, topics = []);
    }
    topics.push(...handlers);
  }

  private unsubscribe(channel, handler?: EventHandler): boolean {
    if (!handler) {
      return this.c.delete(channel);
    }
    const topics = this.c.get(channel);
    if (!topics) {
      return false;
    }
    const index = topics.indexOf(handler);
    if (index < 0) {
      return false;
    }
    topics.splice(index, 1);
    if (topics.length === 0) {
      this.c.delete(channel);
    }
    return true;
  }

  private publish(channel: string, body: any): EventHandler[] | null {
    const topics = this.c.get(channel);
    if (!topics) {
      return null;
    }
    return topics.map(handler => {
      try {
        return handler(body);
      } catch (e) {
        console.error(e);
        return null;
      }
    });
  }
}


// WEBPACK FOOTER //
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/app/modal/services/modal.service.ts